module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/secondary_address.js
// module id = 1169
// module chunks = 0